import Vue from "vue";

// When the request succeeds
const success = (data, context) => {
  context.airbnbAccounts = data.airbnb_accounts;
  // context.airbnbAccountsNotSync = data.airbnb_accounts_not_sync;
  context.airbnbRentalsNotSync = data.airbnb_rentals_not_sync;
  context.loading = false;
  context.$store.commit("AIRBNB_SHOULD_SYNC", 0);
};

// When the request fails
const failed = (error, context) => {
  if (error.code && error.code === "auth_error") {
    context.$store.commit("AIRBNB_SHOULD_SYNC", 1);
  }
  toastr.error(error);
};

export default (context) => {
  return Vue.$http
    .get("/get-airbnb-accounts")
    .then((response) => {
      if (response && response.status === 200) {
        success(response.data, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/getAirbnbAccounts.js